import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN } from '../../theme';

const useStyles = (background, isSingleQuoteBlock) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        zIndex: 1,
        position: 'relative',
        paddingTop: MIDDLE_MARGIN,
        paddingBottom: MIDDLE_MARGIN,
        background: theme.palette.secondary.dark,
        '& .swiper-wrapper': {
          alignItems: 'center',
        },
        '& .swiper-button-next-quote, & .swiper-button-prev-quote': {
          width: 30,
          height: 86,
          display: 'flex',
        },
        '& .swiper-button-next-quote::after, & .swiper-button-prev-quote::after': {
          width: 9,
          height: 16,
          fontSize: 16,
        },
        [theme.breakpoints.up('sm')]: {
          '& .swiper-button-next-quote::after, & .swiper-button-prev-quote::after': {
            width: 12,
            height: 24,
            fontSize: 24,
          },
        },
        [theme.breakpoints.up('md')]: {
          paddingTop: isSingleQuoteBlock ? 108 : LARGE_MARGIN,
          paddingBottom: isSingleQuoteBlock ? 108 : LARGE_MARGIN,
          backgroundColor:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },
      },
      imageWrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        zIndex: -1,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
          background: fade(colorsPalette.blueDark, 0.33),
        },
      },
      imageLazyloadWrapper: {
        width: '100%',
        height: '100%',
      },
      image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      singleContainer: {
        maxWidth: 800,
      },
    }),
  );

export default useStyles;
